import { mergeDeepRight } from "ramda";
import tagsStyles from "./TagsStyles";

export default (theme) =>
  mergeDeepRight(tagsStyles(theme), {
    tag: {
      height: "20px",
      lineHeight: "20px",
      margin: "0 0 0 4px",
    },
    tagText: {
      fontSize: "10px",
      fontWeight: "400",
      display: "inline-block",
      position: "relative",
      top: "50% !important",
      transform: "translateY(-50%)",
    },
  });
